// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3-Ob_","cell":"ColumnAccessor_cell__7PI5S","firstCellAccent":"ColumnAccessor_firstCellAccent__3kyZk"};